import { axiosAiq } from 'config';

export const fetchLocationsWithGates = async () => {
    const response = await axiosAiq.get('/locations/with-gates');
    const { data } = response;
    return data;
};

export const fetchSavedDesks = async () => {
    const response = await axiosAiq.get('/desks/gates');
    const { data } = response;
    return data;
};

/**
 * Submits only the changed location-to-desk mappings. The backend answers with an empty 200: it
 * stores exactly what was sent, so there is nothing to read back.
 */
export const updateDeskSaturation = async (changedDesks) => {
    await axiosAiq.patch('/desks/gates', changedDesks);
};

export const fetchDivisions = async () => {
    const response = await axiosAiq.get('/divisions');
    const { data } = response;
    return data;
};

export const fetchDivisionById = async (id) => {
    const response = await axiosAiq.get(`/desks/gates?divisionId=${id}`);
    const { data } = response;
    return data;
};

export const fetchLocationsByDivision = async (id) => {
    const response = await axiosAiq.get(`/locations/with-gates?divisionId=${id}`);
    const { data } = response;
    return data;
};
